import React, { useState, useEffect } from "react";
import { getFirestore, collection, addDoc, getDocs } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, auth, storage } from "../config/firebaseConfig";

const AfisOlustur = () => {
  const [imageFile, setImageFile] = useState(null);
  const [imageTitle, setImageTitle] = useState('');
  const [imageDescription, setImageDescription] = useState('');
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [isAddingCategory, setIsAddingCategory] = useState(false);
  const [error, setError] = useState(null);

  // Firestore'dan kategorileri çek
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "gallery"));
        const categoryList = [...new Set(querySnapshot.docs.map(doc => doc.data().category))];
        setCategories(categoryList.length > 0 ? categoryList : ['Afiş']);
        setCategory(categoryList[0] || 'Afiş');
      } catch (error) {
        console.error("Kategoriler alınamadı:", error);
        setCategories(['Afiş']);
        setCategory('Afiş');
        setError("Kategoriler yüklenirken hata oluştu.");
      }
    };

    fetchCategories();
  }, []);

  // Resmi Firebase Storage'a yükleyip Firestore'a kaydet
  const uploadToFirebaseStorageAndSaveToFirestore = async () => {
    setError(null);
    try {
      if (!imageFile) throw new Error("Lütfen bir resim seçin.");

      const fileName = `${Date.now()}_${imageFile.name}`;
      const imageRef = ref(storage, `gallery/${fileName}`);

      await uploadBytes(imageRef, imageFile);
      const url = await getDownloadURL(imageRef);

      const newDocRef = await addDoc(collection(db, "gallery"), {
        title: imageTitle,
        description: imageDescription,
        imageUrl: url,
        createdAt: new Date(),
        category: category,
      });

      if (!categories.includes(category)) {
        setCategories([...categories, category]);
      }

      console.log("Yeni döküman ID:", newDocRef.id);
      alert("Resim başarıyla yüklendi!");

      // Formu sıfırla
      setImageFile(null);
      setImageTitle('');
      setImageDescription('');
      setCategory(categories[0]);

    } catch (error) {
      console.error("Yükleme hatası:", error);
      setError(`Yükleme başarısız: ${error.message}`);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!imageFile) {
      setError("Lütfen bir resim seçin.");
      return;
    }
    if (!category) {
      setError("Lütfen bir kategori seçin veya ekleyin.");
      return;
    }
    uploadToFirebaseStorageAndSaveToFirestore();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setError(null);
    }
  };

  const addNewCategory = () => {
    const trimmed = newCategory.trim();
    if (!trimmed) {
      alert("Lütfen bir kategori adı girin.");
      return;
    }
    if (categories.includes(trimmed)) {
      alert("Bu kategori zaten mevcut.");
      return;
    }
    setCategory(trimmed);
    setCategories([...categories, trimmed]);
    setNewCategory('');
    setIsAddingCategory(false);
    alert("Yeni kategori eklendi.");
  };

  // Kullanıcı oturum kontrolü
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        window.location.href = "/login";
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="bg-light font-sans min-vh-100">
      <main className="container py-5">
        <h2 className="h3 mb-4">Fotoğraf Yükleme</h2>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="form-group">
          <div className="mb-3">
            <label htmlFor="image-title" className="form-label">Fotoğraf Başlığı</label>
            <input
              type="text"
              id="image-title"
              value={imageTitle}
              onChange={(e) => setImageTitle(e.target.value)}
              className="form-control"
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="image-description" className="form-label">Fotoğraf Açıklaması</label>
            <textarea
              id="image-description"
              value={imageDescription}
              onChange={(e) => setImageDescription(e.target.value)}
              rows="3"
              className="form-control"
              required
            ></textarea>
          </div>

          <div className="mb-3">
            <label htmlFor="category" className="form-label">Kategori</label>
            <div className="d-flex align-items-center">
              <select
                id="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="form-control me-2"
                required
              >
                {categories.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => setIsAddingCategory(!isAddingCategory)}
              >
                {isAddingCategory ? "İptal" : "Yeni Ekle"}
              </button>
            </div>

            {isAddingCategory && (
              <div className="mt-2">
                <input
                  type="text"
                  value={newCategory}
                  onChange={(e) => setNewCategory(e.target.value)}
                  placeholder="Yeni kategori adı"
                  className="form-control d-inline-block w-75 me-2"
                />
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={addNewCategory}
                >
                  Ekle
                </button>
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="image-file" className="form-label">Fotoğraf Seçin</label>
            <input
              type="file"
              id="image-file"
              accept="image/*"
              onChange={handleFileChange}
              className="form-control"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary">
            Yükle
          </button>
        </form>
      </main>
    </div>
  );
};

export default AfisOlustur;
